import CloseIcon from "Assets/Icons/CloseIcon";
import InfoIcon from "Assets/Icons/InfoIcon";
import LeftArrow from "Assets/Icons/LeftArrow";
import SliderPaneComponent from "Components/CommonComponents/SliderPaneComponent";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import {
  addDays,
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
} from "date-fns";
import moment from "moment";
import EventTypeFilters from "Pages/MySchedule/EventTypeFilters";
import MySchedulecardList from "Pages/MySchedule/MyScheduleCardList";
import MyScheduleDateList from "Pages/MySchedule/MyScheduleDateList";
import MyScheduleDateListMobile from "Pages/MySchedule/MyScheduleMobile/MyScheduleDateListMobile";
import MarkedLectureViewModal from "Pages/MySchedule/TOCModal/MarkedLectureViewModal";
import TOCModal from "Pages/MySchedule/TOCModal/TOCModal";
import ScheduleTableFilter from "Pages/ScheduleView/ScheduleTableFilter";
import ScheduleViewHeader from "Pages/ScheduleView/ScheduleViewHeader";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Col, Row, Spinner, Tooltip, Modal } from "reactstrap";
import styled from "styled-components";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import { EventTypes } from "utilFunctions/Constants/Constants";
import {
  BASE_URL,
  GET_ASSETS_WITH_SM_ID,
  NOT_MARKED_COMPLIANCE,
  SYLLABUS_COMPLIANCE_LIST,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import { ScheduleStatus } from "utilFunctions/shared/ScheduleStatus";

const DivViewTableContainer = styled<any>("div")`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "20px 20px 20px 48px" : "0px"};
  overflow: hidden !important;
`;
const ScheduledDiv1 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "25%" : "30%"};
  height: 100%;
`;
const ScheduledDiv2 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "75%" : "100%"};
  height: 100%;
`;
const syllabusStatus = [
  { label: "Marked", value: "Marked" },
  { label: "Not marked", value: "Not marked" },
  { label: "Delayed", value: "Delayed" },
  { label: "Upcoming", value: "Upcoming" },
];
export const getStartDate = (date: any) => {
  return format(
    setSeconds(setMinutes(setHours(subDays(new Date(date), 1), 18), 30), 0),
    "yyyy-MM-dd HH:mm:ss"
  );
};
export const getEndDate = (date: any) => {
  return format(
    setSeconds(setMinutes(setHours(new Date(date), 18), 29), 0),
    "yyyy-MM-dd HH:mm:ss"
  );
};
const initialDateRange = {
  startDate: new Date(
    format(
      setSeconds(setMinutes(setHours(subDays(new Date(), 3), 18), 30), 0),
      "yyyy-MM-dd HH:mm:ss"
    )
  ),
  endDate: new Date(
    format(
      setSeconds(setMinutes(setHours(addDays(new Date(), 3), 18), 29), 0),
      "yyyy-MM-dd HH:mm:ss"
    )
  ),
  key: "selection",
};
function MyScheduleHome() {
  const navigate = useNavigate();
  const userInfo = useContext<any>(UserInfoContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const dateHandler = () => {
    console.log("date handler");
  };
  const location = useLocation();
  const { state } = location;
  // Get today's date in the format "YYYY-MM-DD"
  const date = new Date();
  const options: any = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Kolkata",
  };
  const formattedDate = new Intl.DateTimeFormat("en-IN", options).format(date);

  // Reformatting the date to YYYY-MM-DD
  const [day, month, year] = formattedDate.split("/");
  const formattedDateString = `${year}-${month}-${day}`;

  const todayDate = formattedDateString;
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(todayDate);
  const [isNotmarkedVisible, setIsNotmarkedVisible] = useState<any>(false);
  const [filterState, setFilterState] = useState<any>({
    eventType: EventTypes[0]?.value,
  });
  const [isTableFilterApplied, setIsTableFilterApplied] = useState<any>(false);
  const [selectedDateRange, setSelectedDateRange] = useState<any>(null);
  const [lecturePrecheckedNodes, setLecturePrecheckedNodes] = useState<any>([]);
  const [subjectsList, setSubjectsList] = useState<selectInterface[]>(
    userInfo?.subjects ? userInfo.subjects : []
  );
  const [todaySchedules, setTodaySchedules] = useState<any>([]);
  const [isPaneOpenDatePicker, setisPaneOpenDatePicker] =
    useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [ispaneopen, setIspaneOpen] = useState<boolean>(false);
  const [selectedlecture, setSelectedlecture] = useState<any>({});
  const [totalUnmarkedLecture, setTotalUnmarkedLecture] = useState<any>([]);
  const [allCoveredTopics] = useState<any>([]);
  const [uniqueStartTimesArray, setuniqueStartTimesArray] = useState<any>([]);
  const [statusResponseMap, setstatusResponseMap] = useState<any>([]);
  const [planneLecturedList, setplanneLecturedList] = useState<any>([]);
  const [plannedLecture, setplannedLecture] = useState<any>(null);
  const [defaultLecture, setDefaultLecture] = useState<any>(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isLectureViewModal, setIsLectureViewModal] = useState<boolean>(false);
  const [selectedItem, setselectedItem] = useState<any>(EventTypes[0]?.value);
  const [searchedFaculty, setSearchedFaculty] = useState(null);
  const [dateRanges, setDateRanges] = useState([
    {
      startDate: new Date(
        format(
          setSeconds(setMinutes(setHours(subDays(new Date(), 3), 18), 30), 0),
          "yyyy-MM-dd HH:mm:ss"
        )
      ),
      endDate: new Date(
        format(
          setSeconds(setMinutes(setHours(addDays(new Date(), 3), 18), 29), 0),
          "yyyy-MM-dd HH:mm:ss"
        )
      ),
      key: "selection",
    },
  ]);

  const toggle = () => setTooltipOpen(!tooltipOpen);
  const { makeRequest: GetAssets } = usePutPostAPI(
    (data: any) => {
      if (data && data["data"]) {
        navigate("/admin/mylibrary/" + data["data"]["smId"]);
      }
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          error["response"]["data"]["internalCode"] ||
          error["response"]["data"]["message"],
      });
    },
    "Post"
  );
  useEffect(() => {
    if (localStorage.getItem("eventType")) {
      setselectedItem(localStorage.getItem("eventType"));
    }
  }, [localStorage.getItem("eventType")]);
  useEffect(() => {
    if (
      localStorage.getItem("scheduledFilter") &&
      JSON.parse(localStorage.getItem("scheduledFilter") as any)
    ) {
      const parsedFilter = JSON.parse(
        localStorage.getItem("scheduledFilter") as any
      );
      handleSearchFaculty(parsedFilter);
    } else {
      const employeeId =
        searchedFaculty && searchedFaculty != null
          ? searchedFaculty
          : userInfo.employeeId;
      if (employeeId) {
        const filters = [];
        let formValues: any = { ...filterState };
        if (state && state.referrer && state.filterState) {
          const SD = getStartDate(dateRanges[0].startDate);
          const ED = getEndDate(dateRanges[0].endDate);
          const { startDate, endDate } = state.filterState;
          if (SD == startDate && ED == endDate) {
            formValues = { ...state.filterState };
          }
        }
        delete formValues["isClear"];
        let newUrl = SYLLABUS_COMPLIANCE_LIST + `?facultyId=${employeeId}`;
        if (formValues == undefined) {
          newUrl =
            newUrl +
            `&startDate=${dateRanges[0].startDate}&endDate=${dateRanges[0].endDate}`;
        } else {
          if (
            state &&
            state?.isTodaySchedule &&
            formValues.startDate == undefined &&
            formValues.endDate == undefined
          ) {
            window.history.replaceState(null, "", location.pathname);
            newUrl = getUrlWithDate(newUrl, formValues);
            setDateRanges(state.dateRanges);
            if (state?.batchDetail) {
              if (state?.batchDetail?.syllabusStatus == "Upcoming") {
                window.open(state?.batchDetail?.eventLink, "_blank");
              } else {
                if (state?.batchDetail?.syllabusStatus == "Marked") {
                  setIsLectureViewModal(!isLectureViewModal);
                  setSelectedlecture(state?.batchDetail);
                } else {
                  handleMarkSyllbus(
                    state?.batchDetail,
                    state?.batchDetail?.syllabusStatus == "Marked"
                      ? "view"
                      : "mark"
                  );
                }
              }
            }
          } else if (
            state &&
            state.isNotMarkedVisible &&
            Object.keys(formValues).length === 0 &&
            !isNotmarkedVisible
          ) {
            newUrl = NOT_MARKED_COMPLIANCE + `?facultyId=${employeeId}`;
            window.history.replaceState(null, "", location.pathname);
            setIsNotmarkedVisible(!isNotmarkedVisible);
          } else if (
            Object.keys(formValues).length &&
            formValues.startDate &&
            formValues.endDate
          ) {
            newUrl = newUrl + "";
          } else {
            if (localStorage.getItem("eventType")) {
              newUrl = getUrlWithDate(newUrl, {
                eventType: localStorage.getItem("eventType"),
              });
            } else {
              newUrl = getUrlWithDate(newUrl, formValues);
            }
          }
        }
        if (formValues) {
          formValues["startDate"] =
            formValues &&
            formValues["startDate"] &&
            formValues["startDate"] != "" &&
            formValues["startDate"] != null
              ? formValues["startDate"]
              : null;
          formValues["endDate"] =
            formValues &&
            formValues["endDate"] &&
            formValues["endDate"] != "" &&
            formValues["endDate"] != null
              ? formValues["endDate"]
              : null;
          formValues["subject"] = formValues?.subject
            ? formValues?.subject?.label
            : null;
          if (localStorage.getItem("eventType")) {
            formValues["eventType"] = localStorage.getItem("eventType");
          }
        }
        for (const key in formValues) {
          if (Object.prototype.hasOwnProperty.call(formValues, key)) {
            if (formValues[key] != null && formValues[key] != "") {
              filters.push(
                encodeURIComponent(key) +
                  "=" +
                  encodeURIComponent(formValues[key])
              );
            }
          }
        }
        if (Array.isArray(filters) && filters.length > 0) {
          newUrl = newUrl + "&" + filters.join("&");
        }
        fetchData(BASE_URL + newUrl, newUrl, employeeId);
      }
    }
  }, [userInfo, filterState, location]);
  useEffect(() => {
    if (state && state.dateRanges) {
      setDateRanges(state.dateRanges);
    }
    if (state && state.filterState) {
      setFilterState(state.filterState);
    }
  }, [location]);
  const getUrlWithDate = (newUrl: any, formValues: any) => {
    console.log(formValues);
    const DR = state && state.dateRanges ? state.dateRanges : dateRanges;
    if (state && state.dateRanges) {
      setDateRanges(state && state.dateRanges);
    }
    const startDate = format(
      setSeconds(
        setMinutes(setHours(subDays(new Date(DR[0].startDate), 1), 18), 30),
        0
      ),
      "yyyy-MM-dd HH:mm:ss"
    );
    const endStart = format(
      setSeconds(setMinutes(setHours(new Date(DR[0].endDate), 18), 29), 0),
      "yyyy-MM-dd HH:mm:ss"
    );
    return newUrl + `&startDate=${startDate}&endDate=${endStart}`;
  };
  const modalCloseHandler = () => {
    setLecturePrecheckedNodes([]);
    toggleModal();
    if (location.state?.referrer) {
      navigate(location.state.referrer, {
        replace: true,
        state: {
          ...location.state,
        },
      });
    } else {
      if (isNotmarkedVisible) {
        const employeeId =
          searchedFaculty && searchedFaculty != null
            ? searchedFaculty
            : userInfo.employeeId;
        const newUrl = NOT_MARKED_COMPLIANCE + `?facultyId=${employeeId}`;
        fetchData(BASE_URL + newUrl, newUrl, employeeId);
      } else {
        const eventType = localStorage.getItem("eventType")
          ? localStorage.getItem("eventType")
          : selectedItem;
        CallMyScheduleApi(eventType);
      }
    }
  };
  useEffect(() => {
    if (userInfo?.subjects) {
      const newSubjectdata: selectInterface[] = [];
      userInfo.subjects.map((item: any) => {
        newSubjectdata.push({
          label: item.subjectName,
          value: item.id,
          key: item.id,
        });
      });
      setSubjectsList(newSubjectdata);
    }
  }, [userInfo]);
  const CallMyScheduleApi = (eventType?: any) => {
    const employeeId =
      searchedFaculty && searchedFaculty != null
        ? searchedFaculty
        : userInfo.employeeId;
    let newUrl = SYLLABUS_COMPLIANCE_LIST + `?facultyId=${employeeId}`;
    const filters = [];
    const formValues: any = { ...filterState };
    if (
      Object.keys(formValues).length &&
      formValues.startDate &&
      formValues.endDate
    ) {
      newUrl = newUrl + "";
    } else {
      const startDate = format(
        setSeconds(
          setMinutes(
            setHours(subDays(new Date(dateRanges[0].startDate), 1), 18),
            30
          ),
          0
        ),
        "yyyy-MM-dd HH:mm:ss"
      );
      const endStart = format(
        setSeconds(
          setMinutes(setHours(new Date(dateRanges[0].endDate), 18), 29),
          0
        ),
        "yyyy-MM-dd HH:mm:ss"
      );
      newUrl = newUrl + `&startDate=${startDate}&endDate=${endStart}`;
    }
    if (formValues) {
      formValues["startDate"] =
        formValues &&
        formValues["startDate"] &&
        formValues["startDate"] != "" &&
        formValues["startDate"] != null
          ? formValues["startDate"]
          : null;
      formValues["endDate"] =
        formValues &&
        formValues["endDate"] &&
        formValues["endDate"] != "" &&
        formValues["endDate"] != null
          ? formValues["endDate"]
          : null;
      formValues["subject"] = formValues?.subject
        ? formValues?.subject?.label
        : null;
    }
    if (eventType) {
      formValues["eventType"] = eventType;
    }
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters) && filters.length > 0) {
      newUrl = newUrl + "&" + filters.join("&");
    }
    fetchData(BASE_URL + newUrl, newUrl, employeeId);
  };
  const getPlannedLecture = async (url: string) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        if (response && response["data"] && response["data"]["data"]) {
          setplanneLecturedList(
            response["data"]["data"]["plannedLectureIdList"]
          );
          setplannedLecture(response["data"]["data"]);
        } else {
          setplanneLecturedList([]);
          setplannedLecture([]);
        }
        setLoading(false);
      },
      failure: (error: any) => {
        setplanneLecturedList([]);
        setplannedLecture([]);
        setLoading(false);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF"
              ? "No Topic Present for this lecture"
              : error.message,
        });
      },
    } as getRequestInterface);
  };
  const fetchData = async (url: string, newUrl: string, employeeId: any) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data?.data?.finalResponseMap;
        if (data && data[todayDate] != undefined) {
          setTodaySchedules(data[todayDate]);
          setDefaultLecture({
            label: convertTime(todayDate, "D MMM, ddd"),
            value: todayDate,
          });
          setData(response?.data?.data);
          setuniqueStartTimesArray(Object.keys(data));
          setstatusResponseMap(response?.data?.data?.statusResponseMap);
          setTotalUnmarkedLecture(response?.data?.data?.totalUnmarkedLectures);
          setSelectedDate(todayDate);
        } else {
          console.log("else is working", selectedItem);
          const dataarray = Object.keys(response?.data?.data?.finalResponseMap);
          const lastindex = dataarray[dataarray.length - 1];
          setTodaySchedules(data[lastindex]);
          setSelectedDate(lastindex);
          setDefaultLecture({
            label: convertTime(lastindex, "D MMM, ddd"),
            value: convertTime(lastindex, "D MMM, ddd"),
          });
          setData(response?.data?.data);
          setstatusResponseMap(response?.data?.data?.statusResponseMap);
          setuniqueStartTimesArray(Object.keys(data));
          setTotalUnmarkedLecture(response?.data?.data?.totalUnmarkedLectures);
        }

        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
      failure: (error: any) => {
        if (
          error &&
          error["response"] &&
          error["response"]["data"] &&
          error["response"]["data"]["internalCode"] &&
          error["response"]["data"]["internalCode"] != "1008"
        ) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: error.message,
          });
        } else if (
          error &&
          error["response"] &&
          error["response"]["data"] &&
          error["response"]["data"]["code"] == "NF" &&
          employeeId != userInfo?.employeeId
        ) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: "No record found for searched faculty",
          });
        }
        setTodaySchedules([]);
        setuniqueStartTimesArray([]);
        setData([]);
        setstatusResponseMap([]);
        setTotalUnmarkedLecture([]);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
    } as getRequestInterface);
  };
  const handleDateSelection = (item: any) => {
    const todayEvent = data?.finalResponseMap[item];
    setSelectedDate(item);
    setTodaySchedules(todayEvent);
  };
  const handleAppliedFilter = (args: any) => {
    console.log("handleAppliedFilter", args);
  };

  const handleMarkSyllbus = (item: any, action: any) => {
    if (["mark"].includes(action)) {
      setIspaneOpen(true);
      getNotMarkerdChapter(item);
    }
    if (["view"].includes(action)) {
      setIsLectureViewModal(!isLectureViewModal);
      setSelectedlecture(item);
      return;
    }
    setSelectedlecture(item);
  };
  const getNotMarkerdChapter = (item: any) => {
    console.log(item);
  };
  const toggleModal = () => {
    setIspaneOpen(!ispaneopen);
  };
  const handleCloseTOCMarker = () => {
    setIspaneOpen(!ispaneopen);
    setLecturePrecheckedNodes([]);
    if (location.state?.referrer) {
      navigate(location.state.referrer, {
        replace: true,
        state: {
          ...location.state,
        },
      });
    } else {
      setLoading(false);
    }
  };
  const NotMarkedChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const notMarked = event.target.checked;
    setIsNotmarkedVisible(notMarked);
    if (notMarked) {
      const employeeId = userInfo.employeeId;
      const newUrl = NOT_MARKED_COMPLIANCE + `?facultyId=${employeeId}`;
      fetchData(BASE_URL + newUrl, newUrl, employeeId);
    } else {
      CallMyScheduleApi();
    }
  };
  const detailShowHandler = (cardData: any) => {
    if (!cardData?.fexRecordId || !cardData?.courseId) {
      ToastDispatch({
        isOpen: true,
        type: "Warning",
        message: "Missing required information to show details.",
      });
      return;
    }
    const obj = {
      lectureId: cardData?.fexRecordId,
      showAssets: true,
      courseId: cardData?.courseId,
    };
    const url = BASE_URL + GET_ASSETS_WITH_SM_ID;
    GetAssets(url, obj);
  };
  const ScheduledHeader = () => {
    return (
      <div className="d-flex justify-content-between w-10">
        <div className="lectureHeading">
          {selectedlecture?.eventName} |{" "}
          {moment(selectedlecture?.startTime).format("D MMM YYYY")}
        </div>
        <CloseIcon
          className="cursorHoverCSS"
          onClick={handleCloseTOCMarker}
        ></CloseIcon>
      </div>
    );
  };
  const editHandler = (lectureAssetsData: any) => {
    if (
      selectedlecture["revisionRank"] &&
      selectedlecture["revisionRank"] != null &&
      selectedlecture["revisionRank"] != 0
    ) {
      const ele = "revision_" + selectedlecture["revisionRank"];
      setLecturePrecheckedNodes([ele]);
    } else {
      const lectureAssetsDataIds = lectureAssetsData.map(
        (item: any) => item.nodeId
      );
      setLecturePrecheckedNodes(lectureAssetsDataIds);
    }
    handleMarkSyllbus(selectedlecture, "mark");
  };
  const returnTodaySchedules = (todaySchedules: any, eventType: string) => {
    if (isNotmarkedVisible) {
      return todaySchedules;
    }
    if (eventType === "ALL") {
      return todaySchedules;
    }
    return (
      todaySchedules &&
      todaySchedules.filter((ele: any) => ele.eventType === eventType)
    );
  };
  const setInitialFilters = (suugest?: any) => {
    const SD = getStartDate(initialDateRange.startDate);
    const ED = getEndDate(initialDateRange.endDate);
    const employeeId =
      suugest && suugest.employeeId ? suugest.employeeId : userInfo.employeeId;
    let newUrl =
      SYLLABUS_COMPLIANCE_LIST +
      `?facultyId=${employeeId}` +
      `&startDate=${SD}&endDate=${ED}`;
    if (selectedItem) {
      newUrl = newUrl + "&eventType=" + selectedItem;
    }
    fetchData(BASE_URL + newUrl, newUrl, employeeId);
    setFilterState({
      eventType: EventTypes[0]?.value,
    });
    setDateRanges([initialDateRange]);
  };
  const handleSearchFaculty = (suugest: any) => {
    if (filterState && filterState.isClear) {
      setInitialFilters(suugest);
    } else {
      let startdate = dateRanges[0].startDate;
      let endDate = dateRanges[0].endDate;
      const formValues: any = { ...filterState };
      const sD = format(
        setSeconds(
          setMinutes(
            setHours(subDays(new Date(dateRanges[0].startDate), 1), 18),
            30
          ),
          0
        ),
        "yyyy-MM-dd HH:mm:ss"
      );
      startdate = formValues["startDate"] ? formValues["startDate"] : sD;

      const eS = format(
        setSeconds(
          setMinutes(setHours(new Date(dateRanges[0].endDate), 18), 29),
          0
        ),
        "yyyy-MM-dd HH:mm:ss"
      );
      endDate = formValues["endDate"] ? formValues["endDate"] : eS;
      let subj;
      if (formValues["subject"]) {
        subj = formValues?.subject ? formValues?.subject?.label : null;
      }
      if (suugest && suugest != null) {
        let SD: any = startdate;
        let ED: any = endDate;
        if (state && state.referrer) {
          SD = getStartDate(state.dateRanges[0].startDate);
          ED = getEndDate(state.dateRanges[0].endDate);
        }
        setSearchedFaculty(suugest.employeeId);
        const employeeId = suugest.employeeId;
        let newUrl =
          SYLLABUS_COMPLIANCE_LIST +
          `?facultyId=${employeeId}` +
          `&startDate=${SD}&endDate=${ED}`;
        if (subj) {
          newUrl = newUrl + "&subject=" + subj;
        }
        if (selectedItem) {
          newUrl = newUrl + "&eventType=" + selectedItem;
        }
        fetchData(BASE_URL + newUrl, newUrl, employeeId);
      } else {
        const startD = dateRanges
          ? getStartDate(dateRanges[0].startDate)
          : startdate;
        const endD = dateRanges ? getEndDate(dateRanges[0].endDate) : endDate;
        setSearchedFaculty(null);
        setDateRanges(dateRanges);
        const employeeId = userInfo.employeeId;
        let newUrl =
          SYLLABUS_COMPLIANCE_LIST +
          `?facultyId=${employeeId}` +
          `&startDate=${startD}&endDate=${endD}`;
        if (subj) {
          newUrl = newUrl + "&subject=" + subj;
        }
        if (selectedItem) {
          newUrl = newUrl + "&eventType=" + selectedItem;
        }
        fetchData(BASE_URL + newUrl, newUrl, employeeId);
      }
    }
  };
  return (
    <>
      {Object.keys(selectedlecture).length &&
      selectedlecture.syllabusStatus == "Marked" ? (
        <MarkedLectureViewModal
          mode="myScheduled"
          selectedlecture={selectedlecture}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          editHandler={editHandler}
        ></MarkedLectureViewModal>
      ) : null}
      <DivViewTableContainer screen={screen}>
        <Card
          className={
            ["xxl", "lg", "xl"].includes(screen)
              ? "filterRowMySchedule"
              : "filterRowMyScheduleMB"
          }
        >
          {["xxl", "lg", "xl"].includes(screen) ? (
            <Row>
              <Col xxl="2" xl="2" lg="3" md="2" sm="12" xs="12">
                <ScheduleViewHeader
                  filterState={filterState}
                  setFilterState={setFilterState}
                  selectedDateRange={selectedDateRange}
                  dateHandler={dateHandler}
                  isPaneOpen={isPaneOpenDatePicker}
                  setisPaneOpen={setisPaneOpenDatePicker}
                />
              </Col>
              <Col
                xxl="10"
                xl="10"
                lg="9"
                md="10"
                sm="12"
                xs="12"
                className={
                  ["xl", "xxl", "lg"].includes(screen) ? "" : "mt-3 mb-2"
                }
              >
                <ScheduleTableFilter
                  isNotmarkedVisible={isNotmarkedVisible}
                  setIsNotmarkedVisible={(isSelected: boolean) => {
                    setIsNotmarkedVisible(isSelected);
                    if (isSelected) {
                      const employeeId =
                        searchedFaculty && searchedFaculty != null
                          ? searchedFaculty
                          : userInfo.employeeId;
                      const newUrl =
                        NOT_MARKED_COMPLIANCE + `?facultyId=${employeeId}`;
                      fetchData(BASE_URL + newUrl, newUrl, employeeId);
                    } else {
                      CallMyScheduleApi();
                    }
                  }}
                  isTableFilterApplied={isTableFilterApplied}
                  setIsTableFilterApplied={setIsTableFilterApplied}
                  userInfo={userInfo}
                  handleFilter={(args: any) => {
                    handleAppliedFilter(args);
                  }}
                  filterState={filterState}
                  setFilterState={setFilterState}
                  syllabusStatus={syllabusStatus}
                  subjects={subjectsList}
                  classes={masters?.classes}
                  open={open}
                  setOpen={setOpen}
                  setSelectedDateRange={setSelectedDateRange}
                  isPaneOpen={isPaneOpenDatePicker}
                  setisPaneOpen={setisPaneOpenDatePicker}
                  dateRanges={dateRanges}
                  setDateRanges={setDateRanges}
                  handleSearchFaculty={handleSearchFaculty}
                  // setSearchedFaculty={setSearchedFaculty}
                />
              </Col>
            </Row>
          ) : (
            <div className="d-flex w-100 flex-column">
              <div className="d-flex justify-content-between w-100">
                <div className="pl-2">
                  <MyScheduleDateListMobile
                    screen={screen}
                    scheduleData={uniqueStartTimesArray}
                    todayDate={selectedDate}
                    handleDateSelection={handleDateSelection}
                    statusResponseMap={statusResponseMap}
                    todaySchedules={todaySchedules}
                    totalUnmarkedLecture={totalUnmarkedLecture}
                    isNotmarkedVisible={isNotmarkedVisible}
                    defaultLecture={defaultLecture}
                    setDefaultLecture={setDefaultLecture}
                    loading={loading}
                  />
                </div>
                <div>
                  <ScheduleTableFilter
                    isNotmarkedVisible={isNotmarkedVisible}
                    setIsNotmarkedVisible={(isSelected: boolean) => {
                      setIsNotmarkedVisible(isSelected);
                      if (isSelected) {
                        const employeeId =
                          searchedFaculty && searchedFaculty != null
                            ? searchedFaculty
                            : userInfo.employeeId;
                        const newUrl =
                          NOT_MARKED_COMPLIANCE + `?facultyId=${employeeId}`;
                        fetchData(BASE_URL + newUrl, newUrl, employeeId);
                      } else {
                        CallMyScheduleApi();
                      }
                    }}
                    isTableFilterApplied={isTableFilterApplied}
                    setIsTableFilterApplied={setIsTableFilterApplied}
                    userInfo={userInfo}
                    handleFilter={(args: any) => {
                      handleAppliedFilter(args);
                    }}
                    filterState={filterState}
                    setFilterState={setFilterState}
                    syllabusStatus={syllabusStatus}
                    subjects={subjectsList}
                    classes={masters?.classes}
                    open={open}
                    setOpen={setOpen}
                    setSelectedDateRange={setSelectedDateRange}
                    isPaneOpen={isPaneOpenDatePicker}
                    setisPaneOpen={setisPaneOpenDatePicker}
                    dateRanges={dateRanges}
                    setDateRanges={setDateRanges}
                    totalUnmarkedLecture={totalUnmarkedLecture}
                    handleSearchFaculty={handleSearchFaculty}
                  />
                </div>
              </div>
              <div className="inputUnmarkedDiv d-flex justify-content-between mt-3">
                <div className="d-flex align-items-center">
                  <input
                    className="form-check-input filterCheckbox mr-2"
                    type="checkbox"
                    checked={isNotmarkedVisible}
                    onChange={NotMarkedChangeHandler}
                  />
                  <div>
                    <ScheduleStatus status={"Unmarked"}></ScheduleStatus>
                    <InfoIcon id={"Tooltip-attendance"}></InfoIcon>
                    <Tooltip
                      placement={"top"}
                      isOpen={tooltipOpen}
                      target={"Tooltip-attendance"}
                      toggle={toggle}
                    >
                      {"Total unmarked lectures till yesterday"}
                    </Tooltip>
                  </div>
                </div>
                <span className="pr-2">
                  <Typography color="black" variant="h6">
                    {totalUnmarkedLecture}
                  </Typography>
                </span>
              </div>
            </div>
          )}
        </Card>
        {loading ? (
          <div className="d-flex flex-row h-50 w-100 justify-content-center align-items-center">
            <Spinner color="info" />
          </div>
        ) : (
          <div className="h-100 d-flex gap-3">
            {["xs", "sm", "md"].includes(screen) ? null : (
              <ScheduledDiv1>
                <MyScheduleDateList
                  screen={screen}
                  scheduleData={uniqueStartTimesArray}
                  todayDate={selectedDate}
                  handleDateSelection={handleDateSelection}
                  statusResponseMap={statusResponseMap}
                  todaySchedules={todaySchedules}
                  totalUnmarkedLecture={totalUnmarkedLecture}
                  isNotmarkedVisible={isNotmarkedVisible}
                  filterState={filterState}
                  dateRanges={dateRanges}
                />
              </ScheduledDiv1>
            )}
            <ScheduledDiv2>
              {EventTypes.length > 0 && !isNotmarkedVisible ? (
                <EventTypeFilters
                  selectedItem={selectedItem}
                  setselectedItem={setselectedItem}
                  todaySchedules={todaySchedules}
                  setFilterState={setFilterState}
                  filterState={filterState}
                  selectedDate={selectedDate}
                  todayDate={todayDate}
                ></EventTypeFilters>
              ) : null}
              <MySchedulecardList
                screen={screen}
                scheduleData={returnTodaySchedules(
                  todaySchedules,
                  selectedItem
                )}
                handleMarkSyllbus={handleMarkSyllbus}
                detailShowHandler={detailShowHandler}
                selectedDate={selectedDate}
                dateRanges={dateRanges}
                filterState={filterState}
              />
            </ScheduledDiv2>
          </div>
        )}
      </DivViewTableContainer>
      {["xs", "sm", "md"].includes(screen) ? (
        <SliderPaneComponent
          isPaneOpen={ispaneopen}
          header={
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <LeftArrow
                  className={"cursorHoverCSS mr-1"}
                  onClick={() => {
                    handleCloseTOCMarker();
                  }}
                />
                <Typography
                  variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                  color="black"
                >
                  Mark Lectures
                </Typography>
              </div>
              <div>
                {selectedlecture?.eventName} |{" "}
                {moment(selectedlecture?.startDate).format("D MMM YYYY")}
              </div>
            </div>
          }
          bodyClassName={"bodyClassName"}
          onRequestClose={() => {
            handleCloseTOCMarker();
          }}
        >
          <TOCModal
            mode="myScheduleHome"
            lecturePrecheckedNodes={lecturePrecheckedNodes}
            setLecturePrecheckedNodes={setLecturePrecheckedNodes}
            selectedlecture={selectedlecture}
            planneLecturedList={planneLecturedList}
            allCoveredTopics={allCoveredTopics}
            plannedLecture={plannedLecture}
            toggleModal={toggleModal}
            userInfo={userInfo}
            getPlannedLecture={getPlannedLecture}
            screen={screen}
            setIspaneOpen={setIspaneOpen}
            modalCloseHandler={modalCloseHandler}
            header={<ScheduledHeader />}
            ispaneopen={ispaneopen}
            state={location.state}
            batchName={selectedlecture?.batchName}
            subject={selectedlecture?.subject}
          ></TOCModal>
        </SliderPaneComponent>
      ) : (
        <Modal
          isOpen={ispaneopen}
          centered={true}
          backdrop={true}
          size={"xl"}
          toggle={() => {
            handleCloseTOCMarker();
          }}
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "syllabusModal"
              : "syllabusModalDK"
          }
        >
          <div
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "modalBodySM"
                : "scheduledBody"
            }
          >
            <TOCModal
              mode="myScheduleHome"
              lecturePrecheckedNodes={lecturePrecheckedNodes}
              setLecturePrecheckedNodes={setLecturePrecheckedNodes}
              selectedlecture={selectedlecture}
              planneLecturedList={planneLecturedList}
              allCoveredTopics={allCoveredTopics}
              plannedLecture={plannedLecture}
              toggleModal={toggleModal}
              userInfo={userInfo}
              getPlannedLecture={getPlannedLecture}
              screen={screen}
              modalCloseHandler={modalCloseHandler}
              header={<ScheduledHeader />}
              ispaneopen={ispaneopen}
              state={location.state}
              batchName={selectedlecture?.batchName}
              subject={selectedlecture?.subject}
            ></TOCModal>
          </div>
        </Modal>
      )}
    </>
  );
}

export default MyScheduleHome;
